import React, { createContext, useContext, useEffect, useState } from 'react';

const GoogleMapsContext = createContext({ loaded: false });
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

export const useGoogleMaps = () => useContext(GoogleMapsContext);

export default function GoogleMapsLoader({ children }) {
  const [loaded, setLoaded] = useState(!!(window.google && window.google.maps));

  useEffect(() => {
    function checkReady() {
      if (window.google && window.google.maps) {
        setLoaded(true);
        return true;
      }
      return false;
    }

    if (checkReady()) return;

    const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        const interval = setInterval(() => {
          if (checkReady()) clearInterval(interval);
        }, 100);
      });
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&region=MA&loading=async`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      const interval = setInterval(() => {
        if (checkReady()) clearInterval(interval);
      }, 100);
    };
    document.head.appendChild(script);
  }, []);

  return (
    <GoogleMapsContext.Provider value={{ loaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}
